import React, { useEffect, useState } from "react";
import { Button, FormControl } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function TelomereLength() {
    const { sample_id } = useParams();

    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const [values, setValues] = useState({
        chemiluminescence: "",
        remark: "",
        data_id: ""
    });

    // ---------- FETCH DATA ----------
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${API_URL}/get-Telomere-Length-data/${sample_id}`
                );

                if (res.data.status && res.data.PiwilMrnaModel) {
                    const row = res.data.PiwilMrnaModel;

                    console.log(res.data.PiwilMrnaModel);
                    setValues({
                        relative_length: row.relative_length ?? "",
                        remark: row.remark ?? "",
                        telomere_id: row.telomere_id
                    });
                }
            } catch (err) {
                console.error("Fetch error:", err);
            }
        };

        fetchData();
    }, [sample_id]);

    // ---------- SAVE DATA ----------
    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/update-Telomere-Length/${values.telomere_id}`,
                {
                    relative_length: values.relative_length,
                    remark: values.remark
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            setSuccessMsg(
                res.data.message || `Telomere Length data saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);

        } catch (err) {
            console.error("Save error:", err);

            if (err.response?.status === 401) {
                setErrorMsg("Unauthorized. Please login again.");
            } else {
                setErrorMsg("Update failed");
            }
        }
    };

    // ---------- UI ----------
    return (
        <div style={{ padding: "40px" }}>
            <h6 style={{ textAlign: "left" }}>Telomere Length</h6>
            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: "30px", marginTop: "40px" }}>
                <div style={{
                    backgroundColor: "#DFF5F1",
                    padding: "20px",
                    borderRadius: "20px",
                    border: "2px solid #4DB6AC",
                    fontWeight: "bold",
                    fontSize: "18px",
                    width: "420px",
                    textAlign: "center"
                }}>
                    Relative telomere length
                </div>

                <FormControl
                    type="number"
                    value={values.relative_length} required
                    onChange={(e) =>
                        setValues({ ...values, relative_length: e.target.value })
                    }
                    style={{
                        width: "150px",
                        height: "70px",
                        fontSize: "18px",
                        textAlign: "center"
                    }}
                />
            </div>

            <FormControl
                as="textarea"
                rows={2}
                placeholder="Enter remarks here"
                value={values.remark}
                onChange={(e) =>
                    setValues({ ...values, remark: e.target.value })
                }
                style={{ width: "600px", marginTop: "30px" }}
            />

            <div className="d-flex justify-content-center mt-4">
                <Button onClick={handleSave}>Save</Button>
            </div>
        </div>
    );
}

export default TelomereLength;
